import { ButtonGroup } from '@mui/material';
import { styled as styledMui } from '@mui/material/styles';

export const MuiButtonGroup = styledMui(ButtonGroup)({
  display: 'flex',
});
